import { useDispatch } from 'react-redux'
import { bindActionCreators } from '@reduxjs/toolkit'
import { authActions } from '../slice/auth.slice'
import { tmpActions } from '../slice/tmp.slice'
import { viewOptionsActions } from '../slice/viewOptions.slice'
import { modalActions } from '../slice/modal.slice'
import { employeesActions } from '../slice/employees.slice'
import { projectsActions } from '../slice/projects.slice'
import { projectEmployeeLinksActions } from '../slice/projectEmployeeLinks.slice'
import { projectManagersActions } from '../slice/projectManagers.slice'
import { userActions } from '../slice/user.slice'
import { ganttActions } from '../slice/gantt.slice'

const actions = {
  ...authActions,
  ...tmpActions,
  ...viewOptionsActions,
  ...modalActions,
  ...employeesActions,
  ...projectsActions,
  ...projectEmployeeLinksActions,
  ...projectManagersActions,
  ...userActions,
  ...ganttActions
}
export const useActions = () => {
  const dispatch = useDispatch()
  return bindActionCreators(actions, dispatch)
}
